import Button from '../../../components/base/Button';

const HeroSection = () => {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/b3d0e899b99dc975f1b73dd7fa38c437.jpg')`
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-transparent to-black/70"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="space-y-8">
          {/* メインロゴ */}
          <div className="space-y-4">
            <h1 className="text-6xl md:text-8xl font-bold" style={{ fontFamily: 'Pacifico, serif' }}>
              <span className="text-transparent bg-gradient-to-r from-red-400 via-yellow-400 via-green-400 via-blue-400 via-indigo-400 via-purple-400 to-pink-400 bg-clip-text animate-pulse">
                ナナイロ
              </span>
            </h1>
            <div className="w-32 h-1 bg-gradient-to-r from-red-400 via-yellow-400 via-green-400 via-blue-400 via-indigo-400 via-purple-400 to-pink-400 mx-auto rounded-full"></div>
          </div>

          {/* サブタイトル */}
          <div className="space-y-4">
            <p className="text-xl md:text-2xl text-white font-bold">
              スロット演者事業
            </p>
            <p className="text-lg md:text-xl text-gray-200 max-w-4xl mx-auto leading-relaxed">
              パチンコ・スロット業界で活動する演者グループ「ナナイロ」<br />
              ホール来店、実戦動画を中心に幅広く活動中。
            </p>
          </div>

          {/* アクションボタン */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" className="shadow-xl">
              <i className="ri-user-star-line mr-2"></i>
              演者プロフィール
            </Button>
            <Button variant="outline" size="lg" className="shadow-xl">
              <i className="ri-calendar-line mr-2"></i>
              来店スケジュール
            </Button>
          </div>
        </div>
      </div>

      {/* スクロール案内 */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
